import { Theme } from "./theme";

export const LightTheme = new Theme({
    primary: "#9160f9"
});

export const DarkTheme = new Theme({
    primary: "#9160f8",
    background: "#202020"
});